import React, { useMemo } from "react";
import Table from "./Table";
import accounting from "accounting";
import _ from "lodash/fp";
import { format, parse } from "date-fns";
import useResizeListener from "./useResizeListener";
import { getBreakpointFromWidth } from "../helpers/index";

function ShoppingCartColumns(props) {
  this.props = props;
  this.simpleAccessor = function(shoppingCart) {
    return shoppingCart;
  };

  this.priceAccessor = function(shoppingCart) {
    return accounting.formatMoney(shoppingCart.total_cost);
  };

  this.getCustomerName = function(shoppingCart) {
    const getFromShoppingCart = _.getOr("", _.placeholder, shoppingCart);
    return `${getFromShoppingCart("customer.first_name")} ${getFromShoppingCart(
      "customer.last_name"
    )}`.trim();
  };

  this.getDate = _.pipe(
    _.getOr("", "created_at"),
    parse,
    date => format(date, "MM/DD/YYYY")
  );

  this.renderShoppingCart = ({ value }) => {
    return (
      <div className="text-left">
        <div className="col-md-auto">
          <p>
            <b>Order Number: </b>
            {_.getOr("", "number_shopping_cart", value)}
          </p>
        </div>
        {this.props.role === "staff" && (
          <div className="col-md-auto">
            <p>
              <b>Customer:</b> {this.getCustomerName(value)}
            </p>
          </div>
        )}
        <div className="col-md-auto">
          <p>
            <b>Total:</b> {this.priceAccessor(value)}
          </p>
        </div>
        <div className="col-md-auto">
          <p>
            <b>Status:</b> {_.getOr("", "state", value)}
          </p>
        </div>
        <div className="col-md-auto">
          <p>
            <b>Date:</b> {this.getDate(value)}
          </p>
        </div>
      </div>
    );
  };

  this.getColumns = function() {
    const { role, breakpoint } = this.props;
    if (breakpoint === "xs" || breakpoint === "sm") {
      return [
        {
          Header: "Order",
          id: "order",
          accessor: this.simpleAccessor,
          Cell: this.renderShoppingCart,
          className: "tdcell"
        }
      ];
    } else {
      const columns = [
        {
          Header: "Number",
          id: "number",
          accessor: "number_shopping_cart",
          className: "tdcell"
        },
        {
          Header: "Total",
          id: "total",
          accessor: this.priceAccessor,
          className: "tdcell"
        },
        {
          Header: "Status",
          id: "state",
          accessor: "state"
        },
        {
          Header: "Date",
          id: "date",
          accessor: this.getDate
        }
      ];
      if (role === "staff") {
        columns.splice(1, 0, {
          Header: "Customer",
          id: "customer",
          accessor: this.getCustomerName,
          Cell: this.renderName,
          className: "tdcell"
        });
      }
      return columns;
    }
  };
}

const ShoppingCartTable = ({ shoppingCarts, role }) => {
  const width = useResizeListener();
  const breakpoint = getBreakpointFromWidth(width);
  const columns = useMemo(() => {
    const shoppingCartColumns = new ShoppingCartColumns({ role, breakpoint });
    return shoppingCartColumns.getColumns();
  }, [breakpoint, role]);
  return <Table data={shoppingCarts} columns={columns} />;
};

export default ShoppingCartTable;
